import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiEdit, CiTrash } from "react-icons/ci";
import { FiPlus } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import { FaPhotoVideo, FaFile, FaTrash, FaEdit } from "react-icons/fa";
import {
  AddModuleMedia,
  createCourseModuleFiles,
  deleteModuleFiles,
  getListCourseModule,
  updateCourseModuleFiles,
  updateModuleMedia,
  updateModuleTitle,
  uploadMedia,
} from "../service";
import CustomSnackbar from "components/snackbar";
import { getCookie } from "utils/setCookie";
const ModuleCourse = ({
  styleModule,
  showNewModuleBox,
  formDataModule,
  setFormDataModule,
  isEditingTitle,
  handleChangeCourseModule,
  mediaUrl,
  setIsEditingTitle,
  styleButtonUpload,
  handleFileChangeAndUpload,
  modules,
  setModules,
  handleOpenModule,
  handleSubmit,
  handleShowNewModuleBox,
  handleSnackbarClose,
  setSnackBarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
}) => {
  const userId = localStorage.getItem("AJAX_USERID");

  const [expanded, setExpanded] = useState(null);
  const [headerText, setHeaderText] = useState<{ [key: string]: string }>({});
  const [editingModuleId, setEditingModuleId] = useState<string | null>(null);
  const [mediaType, setMediaType] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [mediaFileName, setMediaFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleOpenModal = (moduleId, courseId, selectedModule = null) => {
    setSelectedModuleId(moduleId);
    setSelectedCourseId(courseId);
    setOpenModal(true);
    setFile(null);

    setSelectedModule(selectedModule);
    setTitle("");
    setMediaFileName("");
    setSelectedFile(null);
  };

  const handlePreviewChange = (event) => {
    setIsPreview(event.target.checked);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedCourseId(null);
    setSelectedModuleId(null);
  };

  const handleExpandClick = (moduleId) => (event, isExpanded) => {
    if (!isExpanded) {
      event.stopPropagation();
      setExpanded(expanded === moduleId ? null : moduleId);
    }
  };

  const handleEditClick = (moduleId) => (event) => {
    event.stopPropagation();
    setEditingModuleId(moduleId);
  };

  const handleSaveClick = async (moduleId: string) => {
    try {
      const oldModule = modules.find((module) => module._id === moduleId);

      if (!oldModule) {
        console.error("Module not found");
        return;
      }

      const newTitle = headerText[moduleId] || oldModule.title || "";

      await updateModuleTitle(moduleId, newTitle);

      await handleOpenModule(oldModule.course_id);

      setEditingModuleId(null);
      setSnackBarMessage(`Cập nhật thành công`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      setSnackBarMessage("Lỗi khi cập nhật tiêu đề:", error);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setMediaFileName(selectedFile.name);
    }
  };

  useEffect(() => {
    if (selectedModule && selectedModule.media_id) {
      setMediaFileName(selectedModule.media_id.media_file_name || "");
    } else {
      setMediaFileName("");
    }
  }, [selectedModule]);

  const handleDeleteModule = async (id: string) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa module này?")) return;

    try {
      await deleteModuleFiles(id);

      const updatedModules = await getListCourseModule(
        formDataModule.course_id,
        userId
      );
      setModules(updatedModules.data);

      alert("Module đã được xóa thành công!");
    } catch (error) {
      alert("Lỗi khi xóa module. Vui lòng thử lại.");
      console.error("Delete module error:", error);
    }
  };

  const handleSubmitFiles = async (moduleId: string, courseId: string) => {
    setIsLoading(true);

    try {
      let mediaResponse = null;

      if (file) {
        const uploadResponse = await uploadMedia(file, {
          "X-Authorization": getCookie("session"),
        });
        mediaResponse = uploadResponse[0];
      }

      let response = null;

      if (selectedModule) {
        response = await updateCourseModuleFiles(
          selectedModule._id,
          courseId,
          title,
          mediaResponse?.id || selectedModule.media_id?._id,
          selectedModule.parent_id || moduleId,
          file ? mediaResponse?.media_type : selectedModule.type,
          isPreview
        );

        setSnackBarMessage("Cập nhật file thành công");
      } else {
        response = await createCourseModuleFiles(
          courseId,
          title,
          mediaResponse?.id,
          moduleId,
          file ? mediaResponse?.media_type : "file",
          isPreview
        );

        setSnackBarMessage("Thêm file thành công");
      }

      if (response?.data) {
        const updatedModules = await getListCourseModule(courseId, userId);
        setModules(updatedModules.data);
      }

      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenModal(false);
      setSelectedModule(null);
      setFile(null);
    } catch (error) {
      setSnackBarMessage("Thao tác thất bại, xin thử lại!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditModule = (module) => {
    setSelectedModuleId(module._id);
    setSelectedModule(module);
    setSelectedCourseId(module.course_id);
    setTitle(module.title);
    setIsPreview(module.is_preview || false);

    setMediaFileName(module.media_id ? `File ID: ${module.media_id}` : "");

    setOpenModal(true);
  };

  const handleBlur =
    (moduleId: string) =>
    async (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      await handleSaveClick(moduleId);
    };

  const handleTextChange = (moduleId) => (event) => {
    setHeaderText((prevState) => ({
      ...prevState,
      [moduleId]: event.target.value,
    }));
  };

  const handleModuleClick = (module) => {
    if (module.media_id?.media_url) {
      window.open(module.media_id.media_url, "_blank");
    } else {
      console.error("Không tìm thấy media_url");
    }
  };

  return (
    <Box sx={styleModule}>
      {showNewModuleBox && (
        <Box
          sx={{
            boxShadow:
              "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            height: "auto",
            width: "100%",
            p: 2,
            mb: 2,
          }}
        >
          <TextField
            value={formDataModule.course_id}
            onChange={(e) =>
              setFormDataModule((prevState) => ({
                ...prevState,
                course_id: e.target.value,
              }))
            }
            sx={{ display: "none" }}
          />
          {isEditingTitle ? (
            <TextField
              fullWidth
              name="title"
              value={formDataModule.title}
              onChange={(e) =>
                handleChangeCourseModule("title", e.target.value)
              }
              size="small"
              placeholder="Điền tên học phần"
              onBlur={() => setIsEditingTitle(false)}
            />
          ) : (
            <Stack direction="row" gap={2} alignItems="center">
              <Typography>{formDataModule.title}</Typography>
              <CiEdit
                style={{ cursor: "pointer" }}
                onClick={() => setIsEditingTitle(true)}
              />
            </Stack>
          )}

          <Button variant="contained" onClick={handleSubmit} sx={{ mt: 1 }}>
            Thêm
          </Button>
        </Box>
      )}
      <Button
        variant="contained"
        startIcon={<FiPlus />}
        onClick={handleShowNewModuleBox}
      >
        Thêm học phần mới
      </Button>

      <Divider sx={{ mt: 1, mb: 1 }}></Divider>

      <Box>
        <Typography variant="body1" fontWeight={550} mt={2} mb={2}>
          Danh sách học phần
        </Typography>
        {Array.isArray(modules) && modules.length > 0 ? (
          modules.map((module) => (
            <Accordion
              key={module._id}
              expanded={expanded === module._id}
              onChange={(event, isExpanded) =>
                handleExpandClick(module._id)(event, isExpanded)
              }
            >
              <AccordionSummary
                aria-controls="panel1a-content"
                id={`panel1a-header-${module._id}`}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  {editingModuleId === module._id ? (
                    <TextField
                      value={headerText[module._id] || module.title}
                      onChange={(event) =>
                        setHeaderText({
                          ...headerText,
                          [module._id]: event.target.value,
                        })
                      }
                      onBlur={handleBlur(module._id)}
                      variant="standard"
                      autoFocus
                      sx={{ flexGrow: 1 }}
                    />
                  ) : (
                    <Typography
                      sx={{ flexGrow: 1 }}
                      onClick={() => setEditingModuleId(module._id)}
                    >
                      {headerText[module._id] || module.title}
                    </Typography>
                  )}
                  <IconButton
                    onClick={() => handleDeleteModule(module._id)}
                    sx={{ ml: 1 }}
                  >
                    <CiTrash color="red" />
                  </IconButton>
                  <IconButton
                    onClick={handleEditClick(module._id)}
                    sx={{ ml: 1 }}
                  >
                    <CiEdit />
                  </IconButton>
                  <IconButton
                    onClick={(event) =>
                      handleExpandClick(module._id)(
                        event,
                        expanded === module._id
                      )
                    }
                    sx={{ ml: 1 }}
                  >
                    <IoIosArrowDown />
                  </IconButton>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Stack direction="column" gap={2}>
                  {module.children?.map((child) => (
                    <Stack
                      key={child._id}
                      direction="row"
                      gap={2}
                      alignItems="center"
                    >
                      {child.media_id && (
                        <React.Fragment>
                          {child.media_id.media_mime_type?.startsWith(
                            "video"
                          ) ? (
                            <FaPhotoVideo />
                          ) : (
                            <FaFile />
                          )}

                          <Typography
                            variant="body2"
                            onClick={() => handleModuleClick(child)}
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            {child.title}
                          </Typography>
                        </React.Fragment>
                      )}

                      {/* Nút Edit */}
                      <FaEdit
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleEditModule(child)}
                      />

                      {/* Nút Xóa */}
                      <FaTrash
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => handleDeleteModule(child._id)}
                      />
                    </Stack>
                  ))}
                </Stack>

                {/* Nếu module con được chọn, hiển thị file */}
                {selectedModule &&
                  module.children?.some(
                    (child) => child._id === selectedModule
                  ) && (
                    <>
                      {module.children
                        .find((child) => child._id === selectedModule)
                        ?.media_ids?.map((media, index) => (
                          <React.Fragment key={index}>
                            {media.media_mime_type.startsWith("video") ? (
                              <video width="320" height="240" controls>
                                <source
                                  src={media.media_url}
                                  type={media.media_mime_type}
                                />
                                Your browser does not support the video tag.
                              </video>
                            ) : (
                              <embed
                                src={media.media_url}
                                type="application/pdf"
                                width="100%"
                                height="600px"
                              />
                            )}
                          </React.Fragment>
                        ))}
                    </>
                  )}
              </AccordionDetails>

              <Button
                component="label"
                variant="contained"
                startIcon={<FiPlus />}
                sx={styleButtonUpload}
                onClick={() => handleOpenModal(module._id, module.course_id)}
              >
                Thêm VIDEO/FILES cho học phần này
              </Button>

              {openModal && (
                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "80%",
                      maxWidth: "400px",
                      bgcolor: "white",
                      borderRadius: 2,
                      boxShadow: 24,
                      p: 3,
                    }}
                  >
                    <Typography variant="h6">
                      {selectedModule
                        ? "Chỉnh sửa VIDEO/FILES"
                        : "Thêm VIDEO/FILES"}
                    </Typography>

                    <TextField
                      fullWidth
                      label="Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      sx={{ mb: 2 }}
                    />

                    <input
                      type="file"
                      accept="video/*,application/pdf"
                      onChange={handleFileChange}
                      style={{ display: "block", marginBottom: "8px" }}
                    />
                    {mediaFileName && (
                      <Typography variant="body2">
                        File hiện tại: {mediaFileName}
                      </Typography>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isPreview}
                          onChange={handlePreviewChange}
                        />
                      }
                      label="Preview"
                    />

                    <Stack
                      justifyContent="end"
                      alignItems="center"
                      direction="row"
                      gap={1}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          handleSubmitFiles(selectedModuleId, selectedCourseId)
                        }
                        disabled={isLoading}
                      >
                        {selectedModule ? "Cập nhật" : "Thêm"}
                      </Button>

                      <Button
                        onClick={() => setOpenModal(false)}
                        variant="outlined"
                        disabled={isLoading}
                      >
                        Đóng
                      </Button>
                    </Stack>

                    {/* Backdrop cho loading */}
                    <Backdrop
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        bgcolor: "rgba(0, 0, 0, 0.3)",
                        zIndex: 1000,
                      }}
                      open={isLoading}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </Box>
                </Modal>
              )}
            </Accordion>
          ))
        ) : (
          <Typography>Không có học phần nào.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default ModuleCourse;
